import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import DisplayActions from "../../../../../redux/DisplayRedux";
import CheckoutComponent from "../../components/step3_checkout/CheckoutComponent";

const mapStateToProps = (state) => ({
  audience: state.display.audience,
  programmatic: state.display.programmatic,
  amountBudget: state.display.amountBudget,
  date_from: state.display.date_from,
  date_to: state.display.date_to,
  currentCampaign: state.display.currentCampaign,
  campaign: state.display.campaign,
  user: state.userAccount.user,
  creationType: state.display.creationType,
  paymentLoading: state.display.creatingPayment,
  proposalAudience: state.display.proposalAudience,
  campaignAudienceAttributes: state.display.campaignAudienceAttributes,
  cart: state.display.cart,
  customContents: state.display.customContents,
  editCampaignActive: state.display.editCampaignActive,
  pricesData: state.display.pricesData,
  client: state.display.client,
});

const mapDispatchToProps = {
  getProposal: DisplayActions.getProposalRequest,
  getProposalAudience: DisplayActions.getProposalAudienceRequest,
  getCampaignAudienceAttributes:
    DisplayActions.getCampaignAudienceAttributesRequest,
  getAudience: DisplayActions.getAudienceRequest,
  calculatePrices: DisplayActions.calculateCampaignPricesRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(CheckoutComponent));
